import type { FlightsRebookAppState } from "../../../store";

export const getSelectedSegment = (state: FlightsRebookAppState) =>
  state.flightsRebook.selectedSegment;

export const getRebookReturnSlice = (state: FlightsRebookAppState) =>
  state.flightsRebook.shoppingState.data?.returnSlice;

export const getRebookPassengers = (state: FlightsRebookAppState) =>
  state.flightsRebook.shoppingState.data?.passengers;

export const getRebookedFlight = (state: FlightsRebookAppState) =>
  state.flightsRebook.rebookedFlight;

export const getBookingState = (state: FlightsRebookAppState) =>
  state.flightsRebook.bookingState;
